import axios from 'axios'

export const API_HS_NI_ENDPOINT = process.env.REACT_APP_API_HS_NI_ENDPOINT

export const OUT_OF_HOURS_ACTIONS = {
  send: 'send',
  abort: 'abort'
}

const notificacoesInteligentes = {}

notificacoesInteligentes.getQrCodeHiperApiV1 = async (api, secret, provider = 'hiperapi-v1') => {
  // provider permite distinguir o Baileys estável (hiperapi-v1) do canário
  // (hiperapi-v1-next). Default v1 mantém compatibilidade com chamadas antigas.
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/generateQRCode/hiperapi-v1`, {
    clientApi: api,
    clientSecret: secret,
    provider
  })

  return response?.data
}

notificacoesInteligentes.getQrCodeHiperApiV2 = async (api, secret) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/generateQRCode/hiperapi-v2`, {
    clientApi: api,
    clientSecret: secret
  })

  return response?.data
}

notificacoesInteligentes.whatsappBusinessConnectionHiperApiV3CloudApi = async (api, secret, data = {}) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/whatsappBusinessConnection/hiperapi-v3-cloud-api`, {
    clientApi: api,
    clientSecret: secret,
    ...data
  })

  return response?.data
}

notificacoesInteligentes.updateProvider = async (api, secret, provider) => {
  const response = await axios.patch(`${API_HS_NI_ENDPOINT}/instances/microservices/provider`, {
    clientApi: api,
    clientSecret: secret,
    provider
  })

  return response?.data
}

notificacoesInteligentes.getInformations = async (api, secret) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/informations`, {
    clientApi: api,
    clientSecret: secret
  })

  return response?.data
}

// Reconexão via GLA WAutenticator: emite o token de uso único que a extensão usa
// para enviar a sessão do WhatsApp Web ao backend (endpoint browserAuth/token).
notificacoesInteligentes.mintBrowserAuthToken = async (api, secret) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/browserAuth/token`, {
    clientApi: api,
    clientSecret: secret
  })

  return response?.data
}

notificacoesInteligentes.getWabaSnapshot = async (api, secret, { force = false } = {}) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/whatsappBusiness/snapshot`, {
    clientApi: api,
    clientSecret: secret,
    force
  })

  return response?.data
}

notificacoesInteligentes.getMessages = async (api, secret, { offset = 0, limit = 30, phoneLike = undefined, messageLike = undefined, status = undefined, dateBegin = undefined, dateEnd = undefined } = {}) => {
  const response = await axios.get(`${API_HS_NI_ENDPOINT}/messages/microservices/messages`, {
    params: {
      api,
      secret,
      offset,
      limit,
      phoneLike,
      messageLike,
      status,
      dateBegin,
      dateEnd
    }
  })

  return response?.data || []
}

notificacoesInteligentes.getMessagesStatistics = async (api, secret, { offset = 0, limit = 30000, status = undefined, dateBegin = undefined, dateEnd = undefined } = {}) => {
  const response = await axios.get(`${API_HS_NI_ENDPOINT}/messages/microservices/messageStatistics`, {
    params: {
      api,
      secret,
      offset,
      limit,
      status,
      dateBegin,
      dateEnd
    }
  })

  return response?.data?.statistics
}

// Série diária de envios (sucesso/erro/fila por dia, BRT) para o gráfico de
// desempenho. dateBegin/dateEnd seguem a convenção do relatório (dateEnd exclusivo).
notificacoesInteligentes.getReport = async (api, secret, { dateBegin = undefined, dateEnd = undefined } = {}) => {
  const response = await axios.get(`${API_HS_NI_ENDPOINT}/messages/microservices/messageReport`, {
    params: {
      api,
      secret,
      dateBegin,
      dateEnd
    }
  })

  return response?.data?.series || []
}

notificacoesInteligentes.sendMessage = async (api, secret, { message, phone, fileUrl } = {}) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/messages/sendMessage`, {
    clientApi: api,
    clientSecret: secret,
    message: encodeMessage(message, fileUrl),
    phone
  })

  return response?.data
}

notificacoesInteligentes.sendMessageGroup = async (api, secret, { message, phone, fileUrl } = {}) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/messages/sendMessageGroup`, {
    clientApi: api,
    clientSecret: secret,
    message: encodeMessage(message, fileUrl),
    phone
  })

  return response?.data
}

notificacoesInteligentes.resendMessage = async (messageId, api, secret) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/messages/microservices/resendMessage/${messageId}`, {
    clientApi: api,
    clientSecret: secret
  })

  return response?.data
}

notificacoesInteligentes.deleteMessage = async (messageId, api, secret) => {
  const response = await axios.delete(`${API_HS_NI_ENDPOINT}/messages/microservices/delete/${messageId}`, {
    clientApi: api,
    clientSecret: secret
  })

  return response?.data
}

notificacoesInteligentes.changeOfficeHour = async (api, secret, { isEnabled, outOfHoursAction = 'send', days = [] } = {}) => {
  if(![OUT_OF_HOURS_ACTIONS.abort, OUT_OF_HOURS_ACTIONS.send].includes(outOfHoursAction)) {
    throw new Error('outOfHoursAction field invalid')
  }

  const response = await axios.put(`${API_HS_NI_ENDPOINT}/instances/microservices/changeOfficeHourService`, {
    clientApi: api,
    clientSecret: secret,
    officeHourService: {
      active: isEnabled,
      outOfHoursAction,
      days
    }
  })

  return response?.data
}

notificacoesInteligentes.expireQrCode = async (api, secret) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/expireQRCode`, {
    clientApi: api,
    clientSecret: secret
  })

  return response?.data
}

notificacoesInteligentes.restartApi = async (api, secret) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/reboot`, {
    clientApi: api,
    clientSecret: secret
  })

  return response?.data
}

notificacoesInteligentes.activateApi = async (api, secret) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/activate`, {
    clientApi: api,
    clientSecret: secret
  })

  return response?.data
}

notificacoesInteligentes.clearQueue = async (api, secret) => {
  const response = await axios.delete(`${API_HS_NI_ENDPOINT}/instances/microservices/clearQueue`, {
    data: {
      clientApi: api,
      clientSecret: secret
    }
  })

  return response?.data
}

notificacoesInteligentes.clearReport = async (api, secret) => {
  const response = await axios.delete(`${API_HS_NI_ENDPOINT}/messages/microservices/clearHistoric`, {
    data: {
      clientApi: api,
      clientSecret: secret
    }
  })

  return response?.data
}

notificacoesInteligentes.resendMessagesWithErrors = async (api, secret) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/messages/microservices/resendMessageError`, {
    clientApi: api,
    clientSecret: secret
  })

  return response?.data
}

notificacoesInteligentes.deleteMessagesWithErrors = async (api, secret, periodToDelete) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/messages/microservices/clearErrors`, {
    clientApi: api,
    clientSecret: secret,
    periodToDelete
  })

  return response?.data
}

notificacoesInteligentes.changeDisconnectionNotificationNumber = async (api, secret, phone) => {
  const response = await axios.put(`${API_HS_NI_ENDPOINT}/instances/microservices/changeDisconnectionNotificationNumber`, {
    clientApi: api,
    clientSecret: secret,
    disconnectionNotificationNumber: phone
  })

  return response?.data
}

notificacoesInteligentes.changeDailyReportNotificationNumber = async (api, secret, phone) => {
  const response = await axios.put(`${API_HS_NI_ENDPOINT}/instances/microservices/changeDailyReportNotificationNumber`, {
    clientApi: api,
    clientSecret: secret,
    dailyReportNumber: phone
  })

  return response?.data
}

notificacoesInteligentes.updateDefaultMessage = async (api, secret, defaultMessage) => {
  const response = await axios.put(`${API_HS_NI_ENDPOINT}/instances/microservices/updateDefaultMessage`, {
    clientApi: api,
    clientSecret: secret,
    defaultMessage
  })

  return response?.data
}

notificacoesInteligentes.changeMessageTimer = async (api, secret, { timerOverride = undefined, timerNewLine = undefined } = {}) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/setTimerOverride`, {
    clientApi: api,
    clientSecret: secret,
    timerOverride,
    timerNewLine
  })

  return response?.data
}

// Public endpoints
notificacoesInteligentes.getNotifications = async () => {
  const response = await axios.get(`${API_HS_NI_ENDPOINT}/notifications`)
  return response?.data
}

// Helpers
function encodeMessage(message, fileUrl) {
  const filename = getFilenameByUrl(fileUrl)
  const filenameTag = filename === '' ? '' : `%Filename%${filename}%/Filename%`

  return fileUrl === ''
    ? message
    : `${message}%SendFile%${filenameTag}%Url%${fileUrl.split(/\s/).join('')}%/Url%%/SendFile%`
}

function getFilenameByUrl(url) {
  return url ? url.substring(url.lastIndexOf('/') + 1) : ''
}

// ---------------------------------------------------------------------------
// HiperPay — Payment Page Profiles
// ---------------------------------------------------------------------------

export const HIPERPAY_ENDPOINT = process.env.REACT_APP_HIPERPAY_ENDPOINT || 'http://localhost:3003'

const hiperpay = {}

function hiperpayAuthHeader(clientId, clientSecret) {
  return { Authorization: `Basic ${btoa(`${clientId}:${clientSecret}`)}` }
}

hiperpay.getProfiles = async (clientId, clientSecret) => {
  const response = await axios.get(`${HIPERPAY_ENDPOINT}/api/profiles`, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

hiperpay.createProfile = async (clientId, clientSecret, data) => {
  const response = await axios.post(`${HIPERPAY_ENDPOINT}/api/profiles`, data, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

hiperpay.updateProfile = async (clientId, clientSecret, id, data) => {
  const response = await axios.put(`${HIPERPAY_ENDPOINT}/api/profiles/${id}`, data, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

hiperpay.deleteProfile = async (clientId, clientSecret, id) => {
  const response = await axios.delete(`${HIPERPAY_ENDPOINT}/api/profiles/${id}`, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

hiperpay.setDefaultProfile = async (clientId, clientSecret, id) => {
  const response = await axios.patch(`${HIPERPAY_ENDPOINT}/api/profiles/${id}/default`, {}, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

hiperpay.getSettings = async (clientId, clientSecret) => {
  const response = await axios.get(`${HIPERPAY_ENDPOINT}/api/integration/settings`, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

hiperpay.updateSettings = async (clientId, clientSecret, data) => {
  const response = await axios.patch(`${HIPERPAY_ENDPOINT}/api/integration/settings`, data, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

hiperpay.getBanners = async (clientId, clientSecret) => {
  const response = await axios.get(`${HIPERPAY_ENDPOINT}/api/banners`, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

hiperpay.createBanner = async (clientId, clientSecret, data) => {
  const response = await axios.post(`${HIPERPAY_ENDPOINT}/api/banners`, data, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

hiperpay.updateBanner = async (clientId, clientSecret, id, data) => {
  const response = await axios.put(`${HIPERPAY_ENDPOINT}/api/banners/${id}`, data, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

hiperpay.deleteBanner = async (clientId, clientSecret, id) => {
  const response = await axios.delete(`${HIPERPAY_ENDPOINT}/api/banners/${id}`, {
    headers: hiperpayAuthHeader(clientId, clientSecret)
  })
  return response?.data
}

notificacoesInteligentes.setupHiperPay = async (api, secret) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/setupHiperPay`, {
    clientApi: api,
    clientSecret: secret
  })
  return response?.data
}

notificacoesInteligentes.disconnectHiperPay = async (api, secret) => {
  const response = await axios.post(`${API_HS_NI_ENDPOINT}/instances/microservices/disconnectHiperPay`, {
    clientApi: api,
    clientSecret: secret
  })
  return response?.data
}

// ---------------------------------------------------------------------------
// SmartFilter — filtro inteligente de mensagens (proxy via master -> secondary)
// Autentica por header api/secret (o master resolve a instancia e encaminha).
// ---------------------------------------------------------------------------

const smartFilter = {}

function sfConfig(api, secret, extra = {}) {
  // timeout em todas as chamadas do SmartFilter: sem isso, se o backend pendurar
  // (ex.: pool de conexões do secondary esgotado), o axios espera pra sempre e o
  // painel fica "carregando infinito". Com 20s, no pior caso mostra "Falha ao
  // carregar" em vez de spinner eterno. (O proxy do master já corta em 15s.)
  return { headers: { api, secret }, timeout: 20000, ...extra }
}

const SF = `${API_HS_NI_ENDPOINT}/smart-filter`

smartFilter.getSettings = async (api, secret) => {
  const response = await axios.get(`${SF}/settings`, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.updateSettings = async (api, secret, data) => {
  const response = await axios.put(`${SF}/settings`, data, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.listTemplates = async (api, secret) => {
  const response = await axios.get(`${SF}/templates`, sfConfig(api, secret))
  return response?.data?.data || []
}

smartFilter.importTemplate = async (api, secret, code) => {
  const response = await axios.post(`${SF}/templates/${code}/import`, {}, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.listRules = async (api, secret) => {
  const response = await axios.get(`${SF}/rules`, sfConfig(api, secret))
  return response?.data?.data || []
}

smartFilter.createRule = async (api, secret, data) => {
  const response = await axios.post(`${SF}/rules`, data, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.updateRule = async (api, secret, id, data) => {
  const response = await axios.put(`${SF}/rules/${id}`, data, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.toggleRule = async (api, secret, id) => {
  const response = await axios.put(`${SF}/rules/${id}/toggle`, {}, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.deleteRule = async (api, secret, id) => {
  const response = await axios.delete(`${SF}/rules/${id}`, sfConfig(api, secret))
  return response?.data
}

smartFilter.getStats = async (api, secret, { days = 7, dateBegin = undefined, dateEnd = undefined } = {}) => {
  const response = await axios.get(`${SF}/stats`, sfConfig(api, secret, { params: { days, dateBegin, dateEnd } }))
  return response?.data?.data
}

smartFilter.listDecisions = async (api, secret, { limit = 50, skip = 0, decision, source, phone } = {}) => {
  const response = await axios.get(`${SF}/decisions`, sfConfig(api, secret, {
    params: { limit, skip, decision, source, phone }
  }))
  return response?.data
}

smartFilter.getDecisionDetail = async (api, secret, id) => {
  const response = await axios.get(`${SF}/decisions/${id}`, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.getBudget = async (api, secret) => {
  const response = await axios.get(`${SF}/budget`, sfConfig(api, secret))
  return response?.data
}

smartFilter.getDelinquency = async (api, secret, { months, page = 1, limit = 20 } = {}) => {
  const response = await axios.get(`${SF}/delinquency`, sfConfig(api, secret, { params: { months, page, limit } }))
  return response?.data
}

smartFilter.listSuppression = async (api, secret) => {
  const response = await axios.get(`${SF}/suppression`, sfConfig(api, secret))
  return response?.data?.data || []
}

smartFilter.addSuppression = async (api, secret, data) => {
  const response = await axios.post(`${SF}/suppression`, data, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.bulkAddSuppression = async (api, secret, items, { reason = 'manual', notes } = {}) => {
  const response = await axios.post(`${SF}/suppression/bulk`, { items, reason, notes }, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.bulkRemoveSuppression = async (api, secret, phones) => {
  const response = await axios.post(`${SF}/suppression/bulk-delete`, { phones }, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.removeSuppression = async (api, secret, phone) => {
  const response = await axios.delete(`${SF}/suppression/${encodeURIComponent(phone)}`, sfConfig(api, secret))
  return response?.data
}

smartFilter.listAllowList = async (api, secret) => {
  const response = await axios.get(`${SF}/allow-list`, sfConfig(api, secret))
  return response?.data?.data || []
}

smartFilter.addAllowList = async (api, secret, data) => {
  const response = await axios.post(`${SF}/allow-list`, data, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.bulkAddAllowList = async (api, secret, items, { notes } = {}) => {
  const response = await axios.post(`${SF}/allow-list/bulk`, { items, notes }, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.bulkRemoveAllowList = async (api, secret, phones) => {
  const response = await axios.post(`${SF}/allow-list/bulk-delete`, { phones }, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.removeAllowList = async (api, secret, phone) => {
  const response = await axios.delete(`${SF}/allow-list/${encodeURIComponent(phone)}`, sfConfig(api, secret))
  return response?.data
}

smartFilter.resetData = async (api, secret, { deleteBefore } = {}) => {
  const body = deleteBefore ? { deleteBefore } : {}
  const response = await axios.post(`${SF}/reset`, body, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.listApprovals = async (api, secret, { status = 'pending' } = {}) => {
  const response = await axios.get(`${SF}/approvals`, sfConfig(api, secret, { params: { status } }))
  return response?.data?.data || []
}

smartFilter.approveApproval = async (api, secret, id) => {
  const response = await axios.put(`${SF}/approvals/${id}/approve`, {}, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.rejectApproval = async (api, secret, id) => {
  const response = await axios.put(`${SF}/approvals/${id}/reject`, {}, sfConfig(api, secret))
  return response?.data?.data
}

smartFilter.getRuleRanking = async (api, secret, { days = 7, dateBegin = undefined, dateEnd = undefined } = {}) => {
  const response = await axios.get(`${SF}/stats/rule-ranking`, sfConfig(api, secret, { params: { days, dateBegin, dateEnd } }))
  return response?.data?.data || []
}

smartFilter.getHourHeatmap = async (api, secret, { days = 7, dateBegin = undefined, dateEnd = undefined } = {}) => {
  const response = await axios.get(`${SF}/stats/hour-heatmap`, sfConfig(api, secret, { params: { days, dateBegin, dateEnd } }))
  return response?.data?.data || { hours: Array(24).fill(0) }
}

export default {
  notificacoesInteligentes,
  hiperpay,
  smartFilter
}
